import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=10c1c81e&scoped=true"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"
import style0 from "./Filtros.vue?vue&type=style&index=0&id=10c1c81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1c81e",
  null
  
)

export default component.exports